var styleDataHash = "39d129d2";
const injectCss = (() => {
  var css = `.Afsm3{border:0;height:100%;width:100%;z-index:0}.Afsm3,.IZJFa{left:0;position:absolute;top:0}.IZJFa{bottom:0;right:0;z-index:3}.aEeJp{height:0;padding-bottom:56.25%;position:relative}@supports not (contain:inline-size){@media only screen and (max-width:480px){.aEeJp{min-width:auto}}}@container (width < 480px){.aEeJp{min-width:auto}}._3GaZm,.d9Hiw{bottom:0;cursor:move;height:100%;position:absolute;top:0;width:100%;z-index:1}.d9Hiw{align-items:center;background:rgba(0,6,36,.7);display:flex;flex-direction:column;gap:12px;justify-content:center;padding:16px}.YdjX9{color:#fff}._3GaZm~*>*,.d9Hiw~*>*{pointer-events:none}.izRgz{height:0;overflow:hidden;visibility:hidden;width:0}.J1zb3,.izRgz{position:absolute}.J1zb3{align-items:center;background:rgba(0,0,0,.5);color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;right:0;text-align:center;top:0;width:100%;z-index:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var default_video_styles_default = {
  "video_player": "Afsm3",
  "videoOverlay": "IZJFa",
  "video_container": "aEeJp",
  "video_overlay": "_3GaZm",
  "video_pending_overlay": "d9Hiw",
  "video_pending_overlay_loader": "YdjX9",
  "hide_duration": "izRgz",
  "error": "J1zb3"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
